<template>
  <div class="d-flex custom__switch">
    <label
      class="c-switch form-check-label c-switch-3d-success position-relative"
      style="width: 50px"
    >
      <div class="text-center switch__text">
        <small></small>
        <!-- <small class="text-white" v-show="on"><b>SI</b></small>
        <small class="text-dark" v-show="!on"><b>NO</b></small> -->
      </div>
      <input
        ref="switchButton"
        type="checkbox"
        class="c-switch-input form-check-input"
        :name="name"
        @change="handleSwitch"
        :checked="checked"
        value="success"
      />
      <span class="c-switch-slider"></span>
    </label>
    <div class="ml-2" v-on:click="check">{{ label }}</div>
  </div>
</template>
<style lang="scss">
.switch__text {
  small {
    position: absolute;
    z-index: 1;
    top: 4px;
  }
  small:first-child {
    left: 5px;
  }
  small:last-child {
    right: 4px;
  }
}

.custom__switch {
  .c-switch-input:checked ~ .c-switch-slider::before {
    -webkit-transform: translateX(24px);
    transform: translateX(24px);
  }

  .c-switch-input:checked ~ .c-switch-slider::after {
    content: "SI";
    position: absolute;
    left: 5px;
    top: 0;
    color: white;
    font-weight: bold;
  }

  .c-switch-input:not(:checked) ~ .c-switch-slider::after {
    content: "NO";
    position: absolute;
    left: calc(100% - 22px);
    top: 2px;
    color: rgba(146, 75, 75, 0.356);
    font-weight: bold;
    font-size: 12px;
  }
}
</style>

<script>
export default {
  data() {
    return {
      on: false,
    };
  },
  methods: {
    check(e) {
      const checkbox = e.target.parentElement.querySelector(
        "input[type='checkbox']"
      );

      if (checkbox.checked) {
        checkbox.removeAttribute("checked");
      } else {
        checkbox.setAttribute("checked", true);
      }
    },

    handleSwitch(e) {
      this.$emit("switchMethod", e.target);
      this.on = e.target.checked;
    },
  },
  mounted() {
    this.$emit("onMounted", true)
  },
  props: {
    label: String,
    checked: undefined,
    name: "",
  },
};
</script>

